import { inject, Injectable } from '@angular/core';
import {
  TimeFrameUtilService,
} from '@backoffice-frontend/shared/bo/util-masterdata';
import {
  ChartTimeSeries,
  IndividualTimeFrame, TimeFrame,
  TimeSeriesIdentifierInput,
} from '@clean-code/models';

import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExportTableDataService {
  private graphqlService = inject(GraphqlService);

  getTimeSeriesChartData$(
    ids: TimeSeriesIdentifierInput[],
    timeFrame?: TimeFrame,
    showIntraDay = true,
  ): Observable<ChartTimeSeries[]> {
    const query = `
    query($symbols: [TimeSeriesInput!]!, $timeFrame: TimeSeriesTimeFrame, $individualTimeFrame: IndividualTimeFrameInput, $showIntraDay:Boolean!){
      chartTimeSeries(symbols: $symbols, timeFrame: $timeFrame, individualTimeFrame: $individualTimeFrame, showIntraDay: $showIntraDay)
      {
        values
        {
          value
          tradeDate
        }
        frontOfficeName
        longName
        sortOrder
        deliveryDay
        areaMarketArea
        {
          name
        }
        category
        unit
        error {
          message
        }
      }
    }`;

    const variables = {
      symbols: ids,
      timeFrame: null as string,
      individualTimeFrame: null as IndividualTimeFrame,
      showIntraDay,
    };

    TimeFrameUtilService.setTimeFrameVariable(timeFrame, variables);

    return this.graphqlService.query<ChartTimeSeries[]>(query, variables, null);
  }
}
